module.exports = __webpack_public_path__ + "static/media/five_monkey.83ea958a.gif";